import {Component, Input} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {BatchProcessResult} from '@data/interefaces/data.interfaces';
import {BulkBaseComponent} from "@pages/bulk.base.component";
import {ClientPortalUser} from "@data/interefaces/client-portal.interfaces";
import {ClientPortalService} from "@data/client-portal/client-portal.service";
import {displayTableColumns} from "./user-list-bulk.component.ds";
import {FeatureComponentMode} from "@core/enums/core.enums";

@Component({
  selector: 'app-user-list-bulk',
  templateUrl: './user-list-bulk.component.html',
  styleUrls: ['./user-list-bulk.component.scss']
})
export class UserListBulkComponent extends BulkBaseComponent {
  @Input() override selectedRows: ClientPortalUser[] = [];
  protected override formGroup: FormGroup<{ [K in keyof ClientPortalUser]?: FormControl<any> }> = new FormGroup<any>([]);
  protected readonly tableColumns = displayTableColumns;

  protected hasTableauLicenseDefaultValue?: string;
  protected tableauLicenseIsPermanentDefaultValue: string = 'false';

  constructor(private _clientPortalService: ClientPortalService) {
    super();
  }

  protected override initFormGroup(): void {
    this.formGroup = new FormGroup<{ [K in keyof ClientPortalUser]?: FormControl<any> }>(
      {
        hasTableauLicense: new FormControl({
          value: this.hasTableauLicenseDefaultValue,
          disabled: false
        }),
        tableauLicenseIsPermanent: new FormControl({
          value: this.tableauLicenseIsPermanentDefaultValue,
          disabled: false
        }),
      });
  }

  protected override initFieldsByFeatureComponentMode(): void {
    this.title = "Client Portal User List";
    this.subtitle = "Bulk License / Un-license";
    this.submitButtonText = "Save";
    this.updateStage = 2;
    this.formGroup.controls.tableauLicenseIsPermanent?.setValue('false');
  }

  protected override getBatchProcessResultByType(): Promise<BatchProcessResult> {
    return this._clientPortalService.getLatestTableauLicenseBatchProcess();
  }

  protected override startBatchProcess(selectedRows: ClientPortalUser[]): Promise<any> {
    if (!this.formGroup.getRawValue().hasTableauLicense) {
      selectedRows.forEach(user => user.tableauLicenseIsPermanent = false);
    }
    return this._clientPortalService.startTableauLicenseBatchProcess(selectedRows, FeatureComponentMode.BULK_LICENSE)
  }

  protected override validateRowData<T>(rowData: T[]): T[] {
    throw new Error('Method not implemented.');
  }

  getFormControl(controlName: (keyof ClientPortalUser)) {
    return this.getControl<ClientPortalUser>(controlName);
  }

}
